<template>
  <div>
    <StandardComponent
      :id="id"
      :injectionID="iid"
      @update:injectionID="updatedInjectionID"
      @update:standardData="updatedStandardData"
    />
  </div>
</template>

<script>
  import PageTitle from '@/mixins/page-title';
  import StandardComponent from '@/components/block/StandardComponent.vue';

  export default {
    name: 'StandardPage',

    components: {
      StandardComponent,
    },

    mixins: [PageTitle],

    props: {
      id: Number,
      iid: Number,
    },

    data() {
      return {
        pageTitle: 'HPLC Cloud: Standard',
      };
    },

    methods: {
      updatedInjectionID(iid) {
        if (iid == null) {
          this.$router.push({
            name: 'standard',
            params: { id: this.id },
          });
        } else {
          this.$router.push({
            name: 'standard injection',
            params: { id: this.id, iid },
          });
        }
      },
      updatedStandardData(sd) {
        this.pageTitle = `${sd?.name}: Standard HPLC.cloud`;
      },
    },
  };
</script>
